import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import "../styles/ClubhousePalms.css";

// demo images (replace with your images)
import Img1 from "../assets/serene-images/aerial-view-serene.avif";
import Img2 from "../assets/serene-images/GATE-ELONGATED.avif";
import Img3 from "../assets/serene-images/STREET-DRIVE.avif";
import Img4 from "../assets/serene-images/AMPHITHEATER-AND-SUNKEN-SEATING.avif";
import Img5 from "../assets/serene-images/BASKETBALL-COURT.avif";
import Img6 from "../assets/serene-images/BRIDGEWAY.avif";
import Img7 from "../assets/serene-images/KIDS-PLAY-AREA.avif";
import Img8 from "../assets/serene-images/SCULPTURE-WATERBODIES.avif";
import Img9 from "../assets/serene-images/VILLA-FRONT-PERGOLLA-LAWN.avif";
import Img10 from "../assets/serene-images/WATER-FEATURE.avif";
import img4 from "../assets/palms-icons/badminton.png";
import img5 from "../assets/palms-icons/snooker.png";
import img6 from "../assets/palms-icons/landscape.png";
import img7 from "../assets/palms-icons/meeting-room.png";
import img8 from "../assets/palms-icons/little-dumbbell.png";
import img9 from "../assets/palms-icons/ping-pong.png";
import img10 from "../assets/palms-icons/air-hockey.png";
import img11 from "../assets/palms-icons/board-game.png";
import img12 from "../assets/palms-icons/board-meeting.png";
import img13 from "../assets/palms-icons/hall.png";
// Floor plan images
import clubHouse1 from "../assets/palms-images/club-house-1.webp";
import clubHouse2 from "../assets/palms-images/club-house-2.webp";
import clubHouse3 from "../assets/palms-images/club-house-3.webp";


import SereneIllustration from "../assets/palms-images/palms-clubhouse-cutout.avif";






export default function Clubhouse() {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [activeFloorIndex, setActiveFloorIndex] = useState(0);

    const floorPlanData = [
        {
            img: clubHouse1,
            title: "GROUND FLOOR PLAN",
            subTitle: "8238 sft / 23892 sft",
            details: null, // Using points instead

            points: [
                "ENTRY LOBBY – 14' 4½\" X 15' 0\"",
                "DOCTOR ROOM – 11' 0\" X 12' 3\"",
                "GRAND LOUNGE – 18' 0\" X 23' 0\"",
                "LIFT – 8' 3\" X 8' 3\"",
                "DINING – 28' 10½\" X 16' 0\"",
                "BANQUET HALL – 37' 10½\" X 49' 9\"",
                "LADIES TOILET – 11' 4½\" X 10' 6\"",
                "GENTS TOILET – 11' 0\" X 17' 9\"",
                "RECORDS – 5' 6\" X 7' 0\"",
                "BOARD GAMES – 23' 9\" X 31' 0\"",
                "CONFERENCE HALL – 30' 0\" X 15' 9\"",
                "KITCHEN – 20' 0\" X 12' 0\"",
                "STORE – 9' 3\" X 12' 0\"",
                "STORE – 7' 0\" X 5' 6\"",
                "ADMIN – 15' 0\" X 14' 6\"",
                "RECEPTION – 10' 9\" X 8' 9\""
            ]
        },
        {
            img: clubHouse2,
            title: "FIRST FLOOR PLAN",
            subTitle: "5380 sft / 23892 sft",
            details: null,
            description: "LEGEND",
            points: [
                "LOUNGE – 24' 9\" X 14' 0\"",
                "INDOOR GAMES – 24' 0\" X 14' 3\"",
                "BILLIARDS – 34' 0\" X 20' 9\"",
                "LIFT – 8' 3\" X 8' 3\"",
                "LOBBY – 8' 4½\" X 10' 0\"",
                "BADMINTON COURT – 28' 9\" X 67' 9\"",
                "INFORMAL LOUNGE – 28' 9\" X 11' 3\"",
                "LADIES TOILET – 11' 4½\" X 10' 6\"",
                "GENTS TOILET – 14' 0\" X 10' 6\"",
                "STORE – 7' 0\" X 7' 3\"",
                "PING PONG – 32' 0\" X 16' 3\"",
                "SQUASH COURT – 32' 0\" X 20' 0\"",
                "GUEST ROOM 1 – 22' 9\" X 13' 3\"",
                "GUEST ROOM 2 – 22' 9\" X 13' 3\"",
                "GUEST ROOM 3 – 22' 9\" X 13' 3\"",
                "HANDICAP TOILET – 9' 3\" X 6' 6\"",
                "LIFT – 6' 6\" X 6' 6\"",
                "VIEWING GALLERY – 9' 0\" X 19' 9\""
            ]
        },
        {
            img: clubHouse3,
            title: "SECOND FLOOR PLAN",
            subTitle: "8354 sft / 23892 sft",
            details: null,
            description: "LEGEND",
            points: [
                "LOBBY – 8' 4½\" X 10' 0\"",
                "GYMNASIUM – 65' 10½\" X 73' 0\"",
                "LOUNGE – 24' 0\" X 14' 0\"",
                "LIFT – 8' 3\" X 8' 3\"",
                "LIFT – 6' 6\" X 6' 6\"",
                "HANDICAP TOILET – 9' 3\" X 6' 6\"",
                "LADIES TOILET – 11' 4½\" X 10' 6\"",
                "GENTS TOILET – 14' 0\" X 10' 6\""
            ]
        }
    ];
    const features = [
        { title: "Badminton Court", icon: img4, type: "img" },
        { title: "Billiards Zone", icon: img5, type: "img" },
        { title: "Landscape/ Garden", icon: img6, type: "img" },
        { title: "Meeting Room", icon: img7, type: "img" },
        { title: "Gymnasium", icon: img8, type: "img" },
        { title: "Ping Pong", icon: img9, type: "img" },
        { title: "Air Hockey zone", icon: img10, type: "img" },
        { title: "Board Games Zone", icon: img11, type: "img" },
        { title: "Conference Room", icon: img12, type: "img" },
        { title: "Multipurpose Hall", icon: img13, type: "img" },
    ];

    // ✅ Whole section stagger animation
    const sectionStagger = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1,
            },
        },
    };

    // ✅ Bottom → Top + fade + blur (premium)
    const fadeUp = {
        hidden: { opacity: 0, y: 45, filter: "blur(10px)" },
        show: {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            transition: { duration: 0.9, ease: "easeOut" },
        },
    };

    // ✅ Title luxury 3D entry
    const text3D = {
        hidden: {
            opacity: 0,
            y: 60,
            rotateX: 12,
            filter: "blur(10px)",
        },
        show: {
            opacity: 1,
            y: 0,
            rotateX: 0,
            filter: "blur(0px)",
            transition: {
                duration: 1,
                ease: [0.22, 1, 0.36, 1],
            },
        },
    };

    // ✅ Feature grid stagger
    const featureGrid = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.15,
            },
        },
    };

    // ✅ Each feature card animation
    const featureItem = {
        hidden: { opacity: 0, y: 30, scale: 0.98 },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };

    // ✅ Slider container animation (fade)
    const sliderVariant = {
        hidden: { opacity: 0, y: 35, scale: 0.98, filter: "blur(12px)" },
        show: {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            transition: { duration: 1, ease: "easeOut" },
        },
    };

    // ✅ Bottom line animation
    const lineVariant = {
        hidden: { opacity: 0, scaleX: 0 },
        show: {
            opacity: 1,
            scaleX: 1,
            transition: { duration: 1, ease: "easeOut" },
        },
    };

    // ✅ Word by word animation (same as your H1)
    const wordContainer = {
        hidden: {},
        show: {
            transition: {
                staggerChildren: 0.12,
                delayChildren: 0.15,
            },
        },
    };

    const wordVariant = {
        hidden: { y: 35, opacity: 0, filter: "blur(6px)" },
        show: {
            y: 0,
            opacity: 1,
            filter: "blur(0px)",
            transition: { duration: 0.8, ease: "easeOut" },
        },
    };

    // ✅ split title words
    // ✅ remove starting space also
    const line1 = "Designed for moments ".split(" ");
    const line2 = "and community play".split(" ");


    return (
        <motion.section
            className="clubhouse-section py-lg-5"
            id="serene-amenities"
            variants={sectionStagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0.3 }}
        >
            <div className="container py-lg-5">
                {/* Top Heading */}
                <div className="row">


                    <div className="col-lg-7 d-flex align-items-center mt-4 mt-lg-0">

                        <motion.h2
                            className="sage-title display-4"
                            variants={wordContainer}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: false, amount: 0.6 }}
                        >
                            {line1.map((word, i) => (
                                <motion.span
                                    key={`line1-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}

                            <br />

                            {line2.map((word, i) => (
                                <motion.span
                                    key={`line2-${i}`}
                                    variants={wordVariant}
                                    style={{ display: "inline-block", marginRight: "0.35em" }}
                                >
                                    {word}
                                </motion.span>
                            ))}
                        </motion.h2>

                    </div>
                    <div className="col-lg-5 d-flex justify-content-center flex-column">


                        <motion.p className="about-text text-white mb-0" variants={fadeUp}>
                            Overlooking vast green horizons, the Vessella Palms Clubhouse is conceived as a quiet statement of luxury. An exclusive retreat where architecture, nature, and lifestyle align effortlessly.
                        </motion.p>
                    </div>
                </div>



                <div className="mt-4" style={{ width: "100%", height: "1px", backgroundColor: "#ffffff5c" }}></div>

                <div className="row align-items-center g-4 py-lg-5">
                    {/* LEFT SIDE */}
                    <div className="col-lg-6 p-lg-0 p-4">
                        {/* ✅ feature grid with stagger */}
                        <motion.div className="clubhouse-grid" variants={featureGrid}>
                            {features.map((item, index) => (
                                <motion.div className="col-lg-6" key={index} variants={featureItem}>
                                    <div className="clubhouse-feature rounded-2">
                                        <span className="clubhouse-icon">
                                            {item.type === "img" ? (
                                                <img
                                                    src={item.icon}
                                                    alt={item.title}
                                                    className="clubhouse-icon-img"
                                                />
                                            ) : (
                                                item.icon
                                            )}
                                        </span>
                                        <span className="clubhouse-text">{item.title}</span>
                                    </div>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>

                    {/* RIGHT SIDE - Slider */}
                    <motion.div className="col-lg-6 p-lg-0" variants={sliderVariant}>
                        <div className="clubhouse-slider-wrap d-none">
                            <div
                                id="clubhouseCarousel"
                                className="carousel slide"
                                data-bs-ride="carousel"
                            >
                                <div className="carousel-inner rounded-2">
                                    <div className="carousel-item active">
                                        <img
                                            src={Img1}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide1"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img2}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide2"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img3}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide3"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img4}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide4"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img5}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide5"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img6}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide6"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img7}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide7"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img8}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide8"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img9}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide9"
                                        />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src={Img10}
                                            className="d-block w-100 clubhouse-img"
                                            alt="slide10"
                                        />
                                    </div>
                                </div>

                                {/* LEFT ARROW */}
                                <button
                                    className="carousel-control-prev clubhouse-arrow"
                                    type="button"
                                    data-bs-target="#clubhouseCarousel"
                                    data-bs-slide="prev"
                                >
                                    <span className="clubhouse-arrow-box">
                                        <span className="carousel-control-prev-icon" />
                                    </span>
                                </button>

                                {/* RIGHT ARROW */}
                                <button
                                    className="carousel-control-next clubhouse-arrow"
                                    type="button"
                                    data-bs-target="#clubhouseCarousel"
                                    data-bs-slide="next"
                                >
                                    <span className="clubhouse-arrow-box">
                                        <span className="carousel-control-next-icon" />
                                    </span>
                                </button>
                            </div>
                        </div>
                        <img className="img-fluid" src={SereneIllustration} alt="" />
                    </motion.div>
                </div>

                {/* Floor Plans Section */}
                <div className="row g-4 justify-content-center d-none d-lg-flex">
                    {floorPlanData.map((item, index) => (
                        <div className="col-lg-4 col-md-6" key={index}>
                            <motion.div
                                className="floor-plan-card"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.6, delay: index * 0.2 }}
                                viewport={{ once: false, amount: 0.2 }}
                                onClick={() => setSelectedPlan(item)}
                            >
                                <img src={item.img} alt={item.title} className="floor-plan-img img-fluid" />
                                <div className="floor-plan-overlay">
                                    <span className="floor-plan-text p-2 rounded-3">Click for Details</span>
                                </div>
                                <p className="text-center mt-3 fw-semibold" style={{ color: "#ffffffff" }}>{item.title}</p>
                            </motion.div>
                        </div>
                    ))}
                </div>

                <div className="floor-plan-mobile d-lg-none">
                    <div className="floor-plan-mobile-tabs justify-content-center align-items-center mb-3">
                        {floorPlanData.map((item, index) => (
                            <button
                                key={item.title}
                                type="button"
                                className={`floor-plan-mobile-tab ${activeFloorIndex === index ? "active" : ""}`}
                                onClick={() => setActiveFloorIndex(index)}
                            >
                                <span className="floor-plan-mobile-tab-label">
                                    {item.title.replace(" FLOOR PLAN", "")}
                                </span>
                            </button>
                        ))}
                    </div>

                    <motion.div
                        className="floor-plan-mobile-feature mb-4"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: false, amount: 0.2 }}
                        onClick={() => setSelectedPlan(floorPlanData[activeFloorIndex])}
                    >
                        <div className="floor-plan-mobile-media">
                            <img
                                src={floorPlanData[activeFloorIndex].img}
                                alt={floorPlanData[activeFloorIndex].title}
                                className="floor-plan-mobile-img img-fluid"
                            />
                        </div>
                        <div className="floor-plan-mobile-content">
                            <p className="floor-plan-mobile-title mb-2">
                                {floorPlanData[activeFloorIndex].title}
                            </p>
                            <div className="floor-plan-mobile-meta">
                                <span>{floorPlanData[activeFloorIndex].points.length} Spaces</span>
                                <span>Tap for Details</span>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Bottom line */}
                {/* <motion.div
                    className="clubhouse-bottom-line mt-5"
                    variants={lineVariant}
                    style={{ transformOrigin: "left" }}
                /> */}
            </div>

            {/* POPUP MODAL */}
            <AnimatePresence>
                {selectedPlan && (
                    <motion.div
                        className="floor-plan-popup-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setSelectedPlan(null)} // Close on backdrop click
                    >
                        <motion.div
                            className="floor-plan-popup-content"
                            initial={{ scale: 0.9, opacity: 0, y: 20 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 20 }}
                            transition={{ type: "spring", damping: 25, stiffness: 300 }}
                            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking content
                        >
                            <button className="popup-close-btn" onClick={() => setSelectedPlan(null)}>
                                &times;
                            </button>
                            <div className="popup-scroll-area">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h3 className="floor-details-title">
                                            {selectedPlan.title}
                                            {selectedPlan.subTitle && <span className="d-block mt-1 fs-6 opacity-75">{selectedPlan.subTitle}</span>}
                                        </h3>
                                        <div className="floor-details-body">
                                            {selectedPlan.description && <h5 className="mb-3 text-uppercase" style={{ letterSpacing: "1px", color: "#0c4b4f" }}>{selectedPlan.description}</h5>}

                                            {selectedPlan.points ? (
                                                <ol className="ps-3 mb-0">
                                                    {selectedPlan.points.map((point, i) => (
                                                        <li key={i} className="mb-2">{point}</li>
                                                    ))}
                                                </ol>
                                            ) : (
                                                selectedPlan.details
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 d-flex align-items-center justify-content-center mt-4 mt-lg-0">
                                        <img
                                            src={selectedPlan.img}
                                            alt={selectedPlan.title}
                                            className="img-fluid rounded-3"
                                            style={{ maxHeight: '400px', objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.section>
    );
}
